document.addEventListener('DOMContentLoaded', function () {
  const search = document.querySelector('.sec-search');
  const items = document.querySelectorAll('.products-item');
  const worksNone = document.querySelector('.works-none');

  if (!search || !items.length) return;

  const state = {
    category: 'all',
    type: 'all',
  };

  search.addEventListener('click', function (event) {
    const link = event.target.closest('.link');

    if (!link) return;

    event.preventDefault();

    const groupEl = link.closest('[data-filter-group]');
    if (!groupEl) return;

    const group = groupEl.dataset.filterGroup;
    const filter = link.dataset.filter;

    if (!group || !filter) return;

    state[group] = filter;

    groupEl.querySelectorAll('.link').forEach(function (el) {
      el.classList.remove('-active');
    });

    link.classList.add('-active');

    filterItems();
  });

  function filterItems() {
    let visibleCount = 0;

    items.forEach(function (item) {

      const matchCategory =
        state.category === 'all' ||
        item.classList.contains('category-' + state.category);

      const matchType =
        state.type === 'all' ||
        item.classList.contains('type-' + state.type);

      if (matchCategory && matchType) {
        item.classList.remove('is-hidden');
        visibleCount++;
      } else {
        console.log("hidden");
        item.classList.add('is-hidden');
      }
    });

    if (worksNone) {
      if (visibleCount === 0) {
        worksNone.hidden = false;
      } else {
        worksNone.hidden = true;
      }
    }
  }
  
});



(function () {
  const PER_PAGE = 100;   // 1ページあたりの件数
  const SIBLINGS = 1;    // カレントの前後に出すページ数

  const list    = document.querySelector('.sec-list.js-modal-bg');
  const pagerEl = document.querySelector('nav.pagination');
  if (!list || !pagerEl) return;

  const allItems = () => Array.from(list.querySelectorAll('.products-item'));
  // 絞り込みにヒットしている(= is-hidden が無い)アイテム
  const matched  = () => allItems().filter((el) => !el.classList.contains('is-hidden'));

  let currentPage = 1;
  let observer;

  const hadHidden = (str) => /\bis-hidden\b/.test(str || '');
  const observeOpts = {
    attributes: true,
    subtree: true,
    attributeFilter: ['class'],
    attributeOldValue: true,
  };

  function render() {
    const items = matched();
    const totalPages = Math.max(1, Math.ceil(items.length / PER_PAGE));
    if (currentPage > totalPages) currentPage = totalPages;

    const start = (currentPage - 1) * PER_PAGE;
    const end   = start + PER_PAGE;

    // 自分の DOM 書き換えでオブザーバが誤発火しないよう一時停止
    if (observer) observer.disconnect();
    items.forEach((el, i) => {
      el.classList.toggle('is-paged', i < start || i >= end);
    });
    buildPager(totalPages);
    if (observer) observer.observe(list, observeOpts);
  }

  function buildPager(totalPages) {
    if (totalPages <= 1) {
      pagerEl.innerHTML = '';
      pagerEl.style.display = 'none';
      return;
    }
    pagerEl.style.display = '';

    // 表示するページ番号のリスト(0 は省略記号の印)
    const pages = [];
    const push = (p) => { if (!pages.includes(p)) pages.push(p); };
    const first = 1;
    const last  = totalPages;
    const from  = Math.max(first, currentPage - SIBLINGS);
    const to    = Math.min(last, currentPage + SIBLINGS);

    push(first);
    if (from > first + 1) pages.push(0);
    else for (let p = first + 1; p < from; p++) push(p);
    for (let p = from; p <= to; p++) push(p);
    if (to < last - 1) pages.push(0);
    else for (let p = to + 1; p < last; p++) push(p);
    push(last);

    let html = '';
    if (currentPage > 1) {
      html += `<a href="#" class="pagination__arrow pagination__arrow--prev" data-page="${currentPage - 1}"></a>`;
    }
    html += '<div class="pagination__numbers">';
    pages.forEach((p) => {
      if (p === 0) {
        html += `<span class="pagination__ellipsis">...</span>`;
      } else if (p === currentPage) {
        html += `<span class="pagination__number is-current">${p}</span>`;
      } else {
        html += `<a href="#" class="pagination__number" data-page="${p}">${p}</a>`;
      }
    });
    html += '</div>';
    if (currentPage < totalPages) {
      html += `<a href="#" class="pagination__arrow pagination__arrow--next" data-page="${currentPage + 1}"></a>`;
    }
    pagerEl.innerHTML = html;
  }

  // ページャークリック(委譲)
  pagerEl.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-page]');
    if (!btn) return;
    e.preventDefault();
    const page = Number(btn.dataset.page);
    if (page === currentPage) return;
    currentPage = page;
    render();
    window.scrollTo(0, 0); // 常に画面最上部へ(Lenis対策で即時スクロール)
  });

  // 絞り込みで is-hidden が実際に切り替わったときだけ1ページ目に戻して再描画
  observer = new MutationObserver((mutations) => {
    const filterChanged = mutations.some(
      (m) => hadHidden(m.oldValue) !== m.target.classList.contains('is-hidden')
    );
    if (!filterChanged) return;
    currentPage = 1;
    render();
  });
  observer.observe(list, observeOpts);

  // 初期描画
  render();
})();